<template>
  <div id="mapContainer">
    <LayoutContainer :id="content.css_id">
      <UtilityHeadline
        v-if="content.headline_h2"
        :class="`dbc-text-color-${content.headline_h2_color.color}`"
        :text="content.headline_h2"
        :level="2"
        :aos="{ fadeDirection: 'fade-right', delay: 350 }"
        :category="{
          text: content.category_h2,
          color: content.category_h2_color.color,
        }"
      />

      <div aria-hidden="true" :style="{ height: content.height }">
        <LazyMap v-if="showMap" :content="content" />
      </div>

      <UtilityText
        v-if="content.text"
        :class="`dbc-text-color-${content.color_text.color}`"
        :text="content.text"
        :aos="{ fadeDirection: 'fade-right', delay: 500 }"
      />
    </LayoutContainer>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  content: ContentMap
}>()

const showMap = ref(false)

onMounted(() => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        showMap.value = true
      }
    })
  })
  const mapContainer = document.getElementById('mapContainer')!
  observer.observe(mapContainer)
})
</script>
